// extracted by mini-css-extract-plugin
export var centerText = "_dx-8";
export var container = "_dx-0";
export var doughnutContainer = "_dx-7";
export var legend = "_dx-a";
export var legendItemColorDisplay = "_dx-b";
export var legendItemLabel = "_dx-d";
export var legendItemValue = "_dx-c";
export var lg = "_dx-5";
export var maxWidth = "_dx-9";
export var md = "_dx-4";
export var responsive = "_dx-6";
export var sm = "_dx-3";
export var xs = "_dx-2";
export var xxs = "_dx-1";